import { Component, Inject } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { GlobalService } from '../../services/global.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GPID } from '../../models/GPID';
import { WorkItem } from '../../models/work-item';
import { ReAssignReleaseDto } from '../../models/reAssignReleaseDto';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-reassign',
  templateUrl: './user-reassign.component.html',
  styleUrl: './user-reassign.component.scss'
})

export class UserReassignComponent {
  myControl = new FormControl('');
  filteredOptions: Observable<GPID[]> | undefined;
    adminEmitter: any = {
    alter: "alter",
    reAssign: "re-assign",
    releaseStatus: "The selected work Item is already Released",
    apiCallSuccess: "Changes has been Updated",
  };
  gpids: GPID[] = [];
  gpIdsAlter: GPID[] = [];
  gpidPreference: boolean = false;
  isDropDownLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private readonly commonService: CommonService, 
    private readonly dialogRef: MatDialogRef<UserReassignComponent>, 
    private readonly globalVariable: GlobalService) {
  }

  ngOnInit(): void {
    this.getDropDownDetails(this.data.tabfunction);
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }

  getDropDownDetails(tabName: string): void {
    if (tabName == this.adminEmitter.reAssign) {
      this.gpids = [];
      console.log(this.globalVariable.getUserGPID + " - " + this.globalVariable.getSelectedSystemId);
      this.commonService.getReAssignUsers(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId).subscribe(
        (response) => {
          response.forEach((item: any) => {
            if (this.gpidPreference) {
              this.gpids.push({ value: item.userName, name: item.userName });
            } else {
              this.gpids.push({ value: item.userName, name: item.fullName });
            }
          });
        },
        (error) => {
          this.isDropDownLoading = false;
        }
      );
    } else if (tabName == this.adminEmitter.alter) {
      this.gpIdsAlter = [];
      this.commonService.getAlterUsers(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId).subscribe(
        (response) => {
          response.forEach((item: any) => {
            this.gpIdsAlter.push({ value: item.Id, name: item.Name });
          });
        },
        (error) => {
          this.isDropDownLoading = false;
        }
      );
    }
  }

  private _filter(value: string): GPID[] {
    const filterValue = value.toLowerCase();
    return this.gpids.filter(
      (option) =>
        option?.name?.toLowerCase().includes(filterValue) ||
        option?.value?.toLowerCase().includes(filterValue)
    );
  }

  onCancelClick(): void {
    this.dialogRef.close('ok');
  }

  assignReleaseWorkItem(id: any) {
    let action = id == "RELEASE" ? "Releas" : "Assign";
    let workItemIds: any[] = [];
    this.data?.selectedRows.forEach((item: WorkItem) => {
      workItemIds.push(String(item.InstanceId));
    });
    let postObj = new ReAssignReleaseDto();
    postObj.systemId = Number(this.globalVariable.getSelectedSystemId);
    postObj.userGpid = this.globalVariable.getUserGPID;
    postObj.workItemId = workItemIds;
    postObj.queueId = this.data?.queueID;
    postObj.workFlowId = this.data?.workflowID;
    postObj.owningUser = "";
    postObj.assignUserGpid = id == "RELEASE" ? "*" : id;
    this.commonService.assignReleaseWorkItemWorkFlow(postObj).subscribe({
      next: (response: any) => {
        this.gpids = [];
        this.gpIdsAlter = [];
        this.commonService.showMessage(action + "ing WorkItem Completed Successfully!", "success");
        this.onCancelClick();
      },
      error: (error: any) => {
        this.commonService.openErrorDialog("Error while " + action + "ing the workitem. Please retry again.");
        this.commonService.showMessage("Error while " + action + "ing work items.", "error");
        console.log(action + "ing WorkItem Failed!" + error.error);
        this.onCancelClick();
      }
    });
  }
}
